module.exports = __webpack_public_path__ + "2027 HSA User Guide.pdf";